import { render, staticRenderFns } from "./reo-frontend-table.vue?vue&type=template&id=27ae5fd0&scoped=true&"
import script from "./reo-frontend-table.vue?vue&type=script&lang=js&"
export * from "./reo-frontend-table.vue?vue&type=script&lang=js&"
import style0 from "./reo-frontend-table.vue?vue&type=style&index=0&id=27ae5fd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ae5fd0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardActions,VCheckbox,VCol,VContainer,VIcon,VRadio,VRadioGroup,VRow,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27ae5fd0')) {
      api.createRecord('27ae5fd0', component.options)
    } else {
      api.reload('27ae5fd0', component.options)
    }
    module.hot.accept("./reo-frontend-table.vue?vue&type=template&id=27ae5fd0&scoped=true&", function () {
      api.rerender('27ae5fd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/result-components/reo_table/reo-frontend-table.vue"
export default component.exports